import { useCallback, useEffect, useRef } from 'react';

export const useScrollPosition = () => {
  const positionRef = useRef<string>('unset');

  const doSomething = useCallback((_scroll_pos: number) => {
    const tabsContainer = document.getElementById('tabs-container');
    const fixedTabsContainer = document.getElementById('fixed-tabs-container');

    if (
      tabsContainer &&
      tabsContainer.getBoundingClientRect().top <= 10 &&
      positionRef.current === 'unset'
    ) {
      tabsContainer.style.visibility = 'hidden';
      fixedTabsContainer!.style.display = 'flex';
      positionRef.current = 'fixed';
    } else if (
      tabsContainer &&
      tabsContainer.getBoundingClientRect().top > 10 &&
      positionRef.current === 'fixed'
    ) {
      tabsContainer.style.visibility = 'visible';
      fixedTabsContainer!.style.display = 'none';
      positionRef.current = 'unset';
    }
  }, []);

  const scrollListener = useCallback(() => {
    let last_known_scroll_position = 0;
    let ticking = false;

    last_known_scroll_position = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        doSomething(last_known_scroll_position);
        ticking = false;
      });

      ticking = true;
    }
  }, [doSomething]);

  useEffect(() => {
    if (typeof window === 'object') {
      window.addEventListener('scroll', scrollListener, true);
    }

    return () => {
      if (typeof window === 'object') {
        window.removeEventListener('scroll', scrollListener, true);
      }
    };
  }, [scrollListener]);

  return { positionRef };
};

export default useScrollPosition;
